// @flow
import React from 'react';
import { colors } from '../../themes';
import Icon from '../../components/shared/Icons/Icon';
import styles from './locationStyles';

const inlineStyles = {
  locationIcon: { marginLeft: '-1px' },
};

type LocationData = {
  address: ?string,
  city: ?string,
  region: ?string,
  cp?: ?string,
};

type Props = {
  locationData: LocationData,
  withRichData: ?boolean,
};

const propToItemProp = {
  address: 'streetAddress',
  city: 'addressLocality',
  region: 'addressRegion',
  cp: 'postalCode',
};

function formattedLocation(locationData) {
  return Object.entries(locationData)
    .sort()
    .filter(item => item[1])
    .map(([key, value], index, all) => (
      <span key={key}>
        <span itemProp={propToItemProp[key]}>{value}</span>
        {index + 1 < all.length && ', '}
      </span>
    ));
}

function Location({ locationData, withRichData }: Props) {
  const location = formattedLocation(locationData);

  if (!location) {
    return null;
  }

  return (
    <div
      className="location"
      itemScope={withRichData}
      itemProp="address"
      itemType="http://schema.org/PostalAddress"
    >
      <Icon type="map" fill={colors.gray} width={13} style={inlineStyles.locationIcon} />
      <span className="text">{location}</span>
      <style jsx>{styles}</style>
    </div>
  );
}

Location.defaultProps = {
  locationData: {
    city: null,
    address: null,
    area: null,
    region: null,
  },
  withRichData: false,
};

export default Location;



// WEBPACK FOOTER //
// ./app/common/Location/Location.js